module.exports = __webpack_public_path__ + "media/soundtrack.40656bbf.mp3";